import type { HTMLAttributes } from 'react'

export interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  src?: string | null
  alt?: string
  name?: string
  size?: 'sm' | 'md' | 'lg'
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) {
    return parts[0]?.substring(0, 2).toUpperCase() ?? ''
  }
  return ((parts[0]?.[0] ?? '') + (parts[parts.length - 1]?.[0] ?? '')).toUpperCase()
}

export function Avatar({ src, alt, name, size = 'md', className = '', ...props }: AvatarProps) {
  const classes = ['fui-avatar', `fui-avatar-${size}`, className].filter(Boolean).join(' ')

  const initials = name ? getInitials(name) : '?'

  return (
    <div className={classes} {...props}>
      {src ? <img src={src} alt={alt ?? name ?? 'Avatar'} /> : <span>{initials}</span>}
    </div>
  )
}
